export default "__VITE_ASSET__CloHQt4d__"